
/* eslint-disable @typescript-eslint/camelcase */
import { Options, Vue } from "vue-class-component";
import SectionPackageDetail from "./components/section-package-detail.vue";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import Woodpacking from "../../booking/component/woodpacking/index.vue";
import { HeavyWeightSurchargeController } from "@/app/ui/controllers/HeavyWeightSurchargeController";
import SectionAdditionalInfoInterpack from "./components/section-additional-info-interpack.vue";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import SectionFTZ from "./components/section-ftz.vue";
import SectionProductUpselling from "./components/section-product-upselling.vue";
import { flags } from "@/feature-flags";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import ProductPoster from "../../booking/component/product-poster/index.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import SectionSTTManualReference from "./components/section-stt-manual-reference.vue";
import SectionSenderDetail from "./components/section-sender-detail.vue";
import SectionRecipientDetail from "./components/section-recipient-detail.vue";
import SectionGoodsWeight from "./components/section-goods-weight.vue";
import { CommodityController } from "@/app/ui/controllers/CommodityController";
import { RequestListCommodity } from "@/data/payload/api/CommodityApiRequest";
import { ProductConfigurationRuleList } from "@/domain/entities/Product";
import {
  codePhoneCountry,
  detailClientManagement,
  maxKg
} from "../../booking/booking-utils";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
import {
  formatPriceRM,
  formatPriceRP,
  parsingErrorResponse,
  parseByCountry
} from "@/app/infrastructures/misc/Utils";
import {
  formatRawInputByCountry,
  resolveMoneyFormatCountry
} from "@/app/infrastructures/misc/common-library/FormatInputByCountry";
import {
  AddBookingCorporate,
  AddManualBooking,
  CIPLType
} from "@/data/payload/api/BookingRequest";
import DialogPayment from "@/app/ui/components/dialog-payment/index.vue";
import SectionFilterClient from "./components/section-filter-client.vue";
import { CountryData, DistrictData } from "@/domain/entities/Location";
import debounce from "lodash/debounce";
import { InternationalDocumentController } from "@/app/ui/controllers/InternationalDocumentController";
import { DetailClientManagement } from "@/domain/entities/ClientManagement";
import { Insurance } from "@/domain/entities/Insurance";
import { InsuranceController } from "@/app/ui/controllers/InsuranceController";
import { BulkBookingController } from "@/app/ui/controllers/BulkBookingController";
import { RequestDetailRepairBulkBooking } from "@/data/payload/api/BulkApiRequest";
import {
  CommodityData,
  DestinationCity,
  DetailRepairBulkBooking,
  ErrorBookingData,
  OriginCity
} from "@/domain/entities/BulkBooking";
import FooterEditBulkBooking from "@/app/ui/views/shipment/bulk-booking-v2/components/footer-edit-bulk-booking/index.vue";
import { ClientNamePOSData } from "@/domain/entities/Partner";
import { errorRepairPosition } from "../list-bulk-booking-utils";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import { ProductController } from "@/app/ui/controllers/ProductController";
import SectionRepairDocInternational from "./components/section-repair-doc-international/index.vue";
import {
  DocInternationalModelValueType,
  ErrorBookingV3,
  CommodityCIPL
} from "@/domain/entities/CreateBookingV3";
import { ManualBooking } from "@/domain/entities/Booking";
import { FlagsPermissionBulkBookingV2 } from "@/feature-flags/flags-bulk-booking-v2";

interface Diskon {
  isDiscount: boolean;
  totalTariff: number;
  totalAfterDiscount: number;
  totalBeforeDiscount: number;
}
@Options({
  components: {
    SectionPackageDetail,
    Woodpacking,
    SectionAdditionalInfoInterpack,
    SectionFTZ,
    SectionProductUpselling,
    ProductPoster,
    SectionSTTManualReference,
    SectionSenderDetail,
    SectionRecipientDetail,
    SectionGoodsWeight,
    DialogPayment,
    SectionFilterClient,
    FooterEditBulkBooking,
    SectionRepairDocInternational
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name === "login") {
      next();
    }
    if (!this.openSuccess && !this.forceRouter) {
      this.onOpenClosePage(to);
      if (this.answer) {
        this.answer = false;
        next();
      } else {
        next(false);
      }
    } else {
      BookingController.setShowModalSuccess(false);
      next();
    }
  },
  watch: {
    "payload.productName": function() {
      this.fetchSlaEstimation();
    },
    "payload.destinationCity": function() {
      this.fetchSlaEstimation();
    },
    "payload.originCity": function() {
      this.fetchSlaEstimation();
    },
    "payload.destinationDistrict": function() {
      this.fetchSlaEstimation();
    },
    "payload.originDistrict": function() {
      this.fetchSlaEstimation();
    },
    totalChargeableWeight() {
      this.onCallProductTotalChWeightPriceChange();
    },
    "payload.commodityCode"() {
      this.onCallProductTotalChWeightPriceChange();
    },
    "manualBooking.productName"(productName: string) {
      if (
        !this.isLoadingGetRepair &&
        productName !== this.detailRepairBulkBooking.bookingData.productType
      ) {
        this.hasChangedRepairProduct = true;
      }
    },
    showInternationalCiplSection(isVisible: boolean) {
      if (!isVisible) this.resetDocInternationalForm();
    }
  }
})
export default class CreateBookingV2 extends Vue {
  renderDetailCalculation = true;
  isEditTerminated = false;
  answer = false;
  newPath = "";
  hideKgs = false;
  parseByCountry = parseByCountry;
  get countryCode() {
    return AccountController.accountData.isInternalAccount
      ? this.manualBooking.clientName.clientCountry
      : AccountController.accountData.account_type_detail?.countryCode || "ID";
  }

  get isLoading() {
    return MainAppController.loadingModal;
  }

  onGetClientStatus(obj: any) {
    if (!obj) return;

    BookingController.setProductName("");
    this.error.errorMandatoryClientColumn =
      !this.payload.clientName &&
      (this.formType === "client" || this.getAccount.accountType === "client");
    if (!obj.status && !obj.isDO) {
      this.pickProductUpselling(this.manualBooking.clientName);
    }

    if (obj.status) {
      this.resetWhenStatusClientTrue();
    } else {
      this.resetWhenStatusClientFalse(obj);
    }

    if (obj) {
      this.codDfodClient(obj.id);
      this.fetchDetail(obj.id);
      this.manualBooking.clientName.id = obj.id;
    } else {
      this.typeDeliveryClientCOD = false;
      this.typeDeliveryClientDFOD = false;
      this.setValueDeliveryTypeClient();
    }
  }

  typeDeliveryClientCOD = false;
  typeDeliveryClientDFOD = false;
  async codDfodClient(id: number) {
    if (!id) return;
    await detailClientManagement(id);
    this.typeDeliveryClientCOD =
      ClientManagementController.detailClientManagement.clientIsCod;
    this.typeDeliveryClientDFOD =
      ClientManagementController.detailClientManagement.clientIsDfod;
    this.setValueDeliveryTypeClient();
  }

  detailClientManagement = new DetailClientManagement();
  async fetchDetail(clientId: string) {
    this.isClientDO = false;
    this.detailClientManagement = new DetailClientManagement();
    if (!clientId) return;
    await ClientManagementController.getDetailV2(Number(clientId));
    this.isClientDO =
      ClientManagementController.detailClientManagement.clientIsDo;
    this.detailClientManagement =
      ClientManagementController.detailClientManagement;
  }

  setValueDeliveryTypeClient() {
    this.refs = this.$refs;
    this.refs.packageDetail.setStatus(
      this.typeDeliveryClientCOD,
      this.typeDeliveryClientDFOD,
      "non-cod"
    );
  }

  isErrorClient = false;
  isClientDO = false;
  statusCODClient = false;
  isClientCOD = false;
  resetWhenStatusClientTrue() {
    this.isErrorClient = true;
    this.isClientDO = true;
    this.isClientCOD = false;
    this.manualBooking.isCOD = false;
    this.manualBooking.codAmount = 0;
    this.statusCODClient = true;
    this.manualBooking.sttManual = "";
    this.error.sttManual = false;
    this.pickProductUpselling(this.manualBooking.clientName);
  }

  resetWhenStatusClientFalse(obj: any) {
    this.statusCODClient = obj.isDO;
    this.isErrorClient = false;

    if (obj.isDO) {
      this.isClientDO = obj.isDO;
      this.manualBooking.sttManual = "";
      // this.errorCaptionSttManual = "";
      this.error.sttManual = false;
      // this.resetProductUpselling();
    } else {
      if (!this.isProductSelected) {
        this.isClientDO = obj.isDO;
        this.manualBooking.sttManual = "";
        // this.errorCaptionSttManual = "";
        this.error.sttManual = false;
      } else {
        this.isClientDO = obj.isDO;
      }
    }

    if (obj.isCOD) {
      this.isClientCOD = true;
    } else {
      this.isClientCOD = false;
      this.manualBooking.isCOD = false;
      this.manualBooking.codAmount = 0;
      // this.errorCaptionSttManual = "";
      this.error.sttManual = false;
    }
  }

  onCallProductTotalChWeightPriceChange() {
    this.hideKgs =
      this.manualBooking.destinationCity?.code &&
      this.manualBooking.commodityCode?.code;
    if (this.hideKgs) {
      this.pickProductUpselling(this.manualBooking.destinationCity);
    }
  }

  handlerClose() {
    this.isEditTerminated = false;
    this.answer = true;
    this.$router.push(this.newPath);
    BookingController.removeWeightDimensions();
    this.resetProductUpselling();
    this.manualBooking.destinationCity = "";
    BookingController.setErrorDestination(false);
    BookingController.setProductName("");
  }

  handlerCancelClose() {
    this.answer = false;
    this.isEditTerminated = false;
  }

  formatPrice(value: number) {
    return !AccountController.accountData.accountIsForeign
      ? formatPriceRP(value)
      : formatPriceRM(value);
  }

  async onCloseSuccess() {
    this.refs = this.$refs;
    const tempSenders = JSON.parse(
      JSON.stringify({
        customerName: this.payload.sender,
        customerAddress: this.payload.addressSender,
        customerPhoneCode: this.payload.phoneCodeSender,
        customerPhoneflag: this.payload.phoneFlagSender,
        customerPhoneNumber: this.payload.phoneSender
      })
    );
    this.resetPageCreateBooking();
    this.resetProductUpselling();
    this.resetAdditionalInfoInterpack();
    BookingController.removeWeightDimensions();
    BookingController.setWeightDimensions({
      grossWeight: !this.$route.query.weight ? "0" : this.$route.query.weight,
      dimension: !this.$route.query.length
        ? {
            length: 3,
            width: 20,
            height: 10
          }
        : {
            length: Number(this.$route.query.length),
            width: Number(this.$route.query.width),
            height: Number(this.$route.query.height)
          },
      volumeWeight: 0.16,
      convertVolumeWeight: "0,16",
      errorHws: false
    });
    this.manualBooking.isWoodpack = false;
    const renderWoodPacking: any = this.$refs.woodpacking;
    renderWoodPacking.resetData();

    this.refs.senderDetail.onChooseSenders(tempSenders, false);
    this.listKGs = BookingController.weightDimensions.data;
    await this.$nextTick();
    this.refs.goodsWeight?.calculationVolumeWeight(0);
    this.refs.packageDetail.automaticSetCheckbox(0);
    this.refs.packageDetail.setInsurance();
    this.scrollToTop();
  }

  scrollToTop() {
    const el = document.getElementById("detailLayoutData");
    if (!el) {
      return;
    }
    el.scroll({
      top: 0,
      behavior: "smooth"
    });
  }

  onOpenClosePage(to: any) {
    this.isEditTerminated = true;
    this.newPath = to.path;
  }

  get detailRepairBulkBooking() {
    return BulkBookingController.detailRepairBulkBookingData;
  }

  isLoadingGetRepair = false;
  hasChangedRepairProduct = false;
  async getRepairBulkDetail() {
    try {
      this.error.phoneCodeReceiver = false;
      this.error.phoneCodeSender = false;
      this.error.sttManual = false;
      this.isLoadingGetRepair = true;
      this.hasChangedRepairProduct = false;
      this.resetPageCreateBooking();
      this.resetFormbookingFromController();
      this.resetProductUpselling();
      this.resetAdditionalInfoInterpack();
      BookingController.removeWeightDimensions();
      BulkBookingController.setIsErrorRepair(new ErrorBookingData());
      BulkBookingController.setDetailRepairBulkBooking(
        new DetailRepairBulkBooking()
      );
      const res = await BulkBookingController.getDetailRepairBulkBooking(
        new RequestDetailRepairBulkBooking({
          id: this.$route.query.id,
          lastRowNum: 0
        })
      );
      BulkBookingController.setIsErrorRepair(
        BulkBookingController.detailRepairBulkBookingData.errorBookingData
      );
      const initialCodAmount = res.bookingData.codAmount;
      const initialEstimationPrice = res.bookingData.valueOfGoods;
      const initialIsCod =
        res.bookingData.serviceType === "COD" ||
        res.bookingData.serviceType === "DFOD";
      const initialIsDfod = res.bookingData.serviceType === "DFOD";

      await this.onSelectDestination("");
      if (res.bookingData?.clientData?.id !== 0) {
        this.onGetClientStatus(res.bookingData?.clientData);
        this.manualBooking.sttDutyTaxTerms =
          res.bookingData.sttDutyTaxTerms || "DAP";
      }
      if (this.manualBooking.commodityCode.id === 0) {
        this.manualBooking.commodityCode = "";
      }
      if (AccountController.accountData.countryCode === "my") {
        if (!this.manualBooking.phoneCodeSender) {
          this.manualBooking.phoneCodeSender = "+60";
        }
        if (!this.manualBooking.phoneCodeReceiver) {
          this.manualBooking.phoneCodeReceiver = "+60";
        }
      }
      this.manualBooking.sttShipmentId = String(res.bookingData.shipmentId);
      this.manualBooking.sttManual = res.bookingData.manualSttNumber;

      // dont set product type if not available in upselling product list
      BookingController.setProductName(res.bookingData.productType);

      if (initialIsCod) {
        this.manualBooking.isCOD = initialIsCod;
        this.manualBooking.isDFOD = initialIsDfod;
        BookingController.setCOD(initialIsCod);
        BookingController.setDfod(initialIsDfod);
      }
      if (
        initialCodAmount !== undefined &&
        initialCodAmount !== null &&
        initialCodAmount !== ""
      ) {
        const originCountryCode =
          res.bookingData.originCountry?.code ||
          AccountController.accountData?.countryCode?.toUpperCase() ||
          "ID";
        const destinationCountryCode =
          res.bookingData.destinationCity?.countryCode || originCountryCode;
        const moneyCountry = resolveMoneyFormatCountry(
          initialIsCod && destinationCountryCode !== originCountryCode
            ? destinationCountryCode
            : originCountryCode
        );
        this.manualBooking.estimationPrice = this.formatRawMoneyByCountry(
          initialEstimationPrice,
          moneyCountry
        ) as any;
        this.manualBooking.codAmount = this.formatRawMoneyByCountry(
          initialCodAmount,
          moneyCountry
        ) as any;
      }

      this.hydrateDocInternationalForm(res.bookingData);
      this.wireErrorDocInternational(res.errorBookingData);
      this.onUpdateOriginCountryDetail();
      this.onUpdateDestinationCountryDetail();

      setTimeout(() => this.scrollBottom(res.errorBookingData), 1000);
    } catch (error) {
      // error
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          this.$t("bulkBooking.repairDetailFetchFailed"),
          this.getRepairBulkDetail,
          () => {
            this.answer = true;
            this.goBack();
          }
        )
      );
    } finally {
      this.isLoadingGetRepair = false;
    }
  }
  formatRawMoneyByCountry(raw: string | number, country: string): string {
    return formatRawInputByCountry(raw, { type: "money", country });
  }

  hydrateDocInternationalForm(bookingData: any) {
    const ciplItems: CommodityCIPL[] = Array.isArray(bookingData.sttCipl)
      ? bookingData.sttCipl.map((item: any, index: number) => ({
          id: Date.now() + index,
          indexCommodity: 0.01 * (index * 3 + 1),
          indexQuantity: 0.01 * (index * 3 + 2),
          indexGoodsPrice: 0.01 * (index * 3 + 3),
          name: item.item_detail || "",
          commodity: { name: item.item_detail || "", code: "" },
          quantity: String(item.quantity || ""),
          goodsPrice: String(item.item_price || ""),
          num: item?.item_detail_num
        }))
      : [];
    this.docInternationalForm = new DocInternationalModelValueType({
      listCommodityCIPL: ciplItems,
      email: bookingData.sttRecipientEmail || "",
      idNumber: bookingData.sttIdentityNumber || "",
      taxNumber: bookingData.sttInterTaxNumber || "",
      dutyTaxTerms: bookingData.sttDutyTaxTerms || "DAP"
    });
    this.errorDocInternational = new ErrorBookingV3({
      listCommodityCIPLDocInternational: ciplItems.map(() => ["", "", ""])
    });
  }

  wireErrorDocInternational(errorBookingData: any) {
    if (errorBookingData.sttRecipientEmail) {
      const msg = this.getLocalizedErrorMessage(
        errorBookingData.sttRecipientEmail
      );
      this.errorDocInternational.emailDocInternational = msg;
    }
    if (errorBookingData.sttIdentityNumber) {
      const msg = this.getLocalizedErrorMessage(
        errorBookingData.sttIdentityNumber
      );
      this.errorDocInternational.idNumberDocInternational = msg;
    }
    if (errorBookingData.sttInterTaxNumber) {
      const msg = this.getLocalizedErrorMessage(
        errorBookingData.sttInterTaxNumber
      );
      this.errorDocInternational.taxNumberDocInternational = msg;
    }
    const ciplItemsError = Array.isArray(errorBookingData.ciplItems)
      ? errorBookingData.ciplItems
      : [];

    this.ensureCiplItems(ciplItemsError.length);
    this.errorDocInternational.listCommodityCIPLDocInternational = this.docInternationalForm.listCommodityCIPL.map(
      (item, index) => {
        if (!item?.num)
          return [this.getCiplItemErrorMessage(ciplItemsError[index]), "", ""];

        const itemError = ciplItemsError.find((ciplErr: any) => {
          return ciplErr?.item_detail_num === item.num;
        });

        return [this.getCiplItemErrorMessage(itemError), "", ""];
      }
    );
  }

  getLocalizedErrorMessage(error: any): string {
    if (typeof error === "string") return error;
    if (!error || typeof error !== "object") return "";
    if (Array.isArray(error)) {
      return (
        error
          .map((item) => this.getLocalizedErrorMessage(item))
          .find((message) => !!message) || ""
      );
    }

    const locale =
      String(this.countryCode).toUpperCase() === "ID" ? "id" : "en";
    return this.getLocalizedErrorMessage(error[locale] || error.message);
  }

  ensureCiplItems(totalItems: number) {
    const ciplItems = this.docInternationalForm.listCommodityCIPL;

    while (ciplItems.length < totalItems) {
      const index = ciplItems.length;
      ciplItems.push(
        new CommodityCIPL({
          id: Date.now() + index,
          indexCommodity: 0.01 * (index * 3 + 1),
          indexQuantity: 0.01 * (index * 3 + 2),
          indexGoodsPrice: 0.01 * (index * 3 + 3),
          commodity: new CommodityData({ name: "", code: "" })
        })
      );
    }
  }

  getCiplItemErrorMessage(error: any): string {
    if (typeof error === "string") return error;
    if (!error || typeof error !== "object") return "";
    if (Array.isArray(error)) {
      return (
        error
          .map((item) => this.getCiplItemErrorMessage(item))
          .find((message) => !!message) || ""
      );
    }

    const locale =
      String(this.countryCode).toUpperCase() === "ID" ? "id" : "en";
    return this.getCiplItemErrorMessage(
      error[locale] || error.message || error.item_detail || error.itemDetail
    );
  }

  countTotalGrossWeight(arrGrossWeight: any) {
    let indicator = 0;
    arrGrossWeight.map((key: any) => {
      indicator += key;
      return indicator;
    });
    const split = indicator
      .toString()
      .replace(".", ",")
      .split(",");
    const front = split[0];
    const behind = split[1] ? "," + split[1].slice(0, 2) : "";
    return front + behind;
  }

  async mounted() {
    await AccountController.checkAccountLocation();
    if (this.isFormBookManual) this.getCustomerList();
    this.getCommodityList();
    this.getClientID();
    BookingController.setForceRouter(false);
    await this.getCountryList();
    await this.getRepairBulkDetail();
    await ProductController.fetchVolumetricDivisors(this.countryCode);
    this.pickProductUpselling(this.manualBooking.destinationCity);
    BulkBookingController.setIsErrorRepair(
      BulkBookingController.detailRepairBulkBookingData.errorBookingData
    );
    this.fetchDestinationCity("");
    const isErrorEstimationOtopack =
      this.detailRepairBulkBooking.bookingData.productType.includes(
        "OTOPACK"
      ) &&
      this.detailRepairBulkBooking.bookingData.valueOfGoods > 0 &&
      this.detailRepairBulkBooking.bookingData.valueOfGoods < 5000000;
    if (!isErrorEstimationOtopack) {
      this.errorEstimationPrice = this.isErrorRepair.valueOfGoods;
    }
    this.errorCodGoodsPrice = this.isErrorRepair.codAmount;
    this.setCodDfodClient();
    await this.recheckShipmentId();
  }

  resetPageCreateBooking() {
    const tempClient = JSON.parse(
      JSON.stringify(this.manualBooking.clientName)
    );
    const tempOriginCity = JSON.parse(
      JSON.stringify(this.manualBooking.originCity)
    );
    this.currentFieldIndex = 0;
    this.resetFormbookingFromController();
    this.resetDestinationAndCommodity();
    this.renderDetailCalculation = false;
    this.manualBooking.clientName = tempClient;
    this.manualBooking.isWoodpack = false;
    this.manualBooking.originCity = tempOriginCity;
    this.manualBooking.addressReceiverType = "home";
    this.refs = this.$refs;
    if (this.refs.packageDetail) {
      this.refs.packageDetail.setStatus(false, false, "non-cod");
      this.refs.packageDetail.setInsurance();
    }
    this.$nextTick(() => {
      this.renderDetailCalculation = true;
    });
    this.additionalInfo = {
      commodity: "",
      email: "",
      sttInterTaxNumber: "",
      sttIdentityNumber: "",
      files: []
    };
    this.docInternationalForm = new DocInternationalModelValueType();
    this.errorDocInternational = new ErrorBookingV3();
    this.discount = {
      isDiscount: false,
      totalTariff: 0,
      totalAfterDiscount: 0,
      totalBeforeDiscount: 0
    };
    BookingController.setCOD(false);
    BookingController.setDfod(false);
    // this.fileAdjustments = [];
    HeavyWeightSurchargeController.setMinimumHeavyWeightSurcharge({
      value: 0,
      existMinimum: false
    });
    this.showWarningHws = false;
    InsuranceController.setInsurance(new Insurance());
  }

  resetFormbookingFromController() {
    BookingController.setShowModalSuccess(false);
    BookingController.setShowModalManualBooking(false);
    BookingController.setDefaultManualBooking();
    BookingController.setError(false);
    BookingController.setEmptyDestination("");
    BookingController.setIncrementManualBooking();
    BookingController.setGuardBookingSubmit(false);
  }

  resetDestinationAndCommodity() {
    const tempProduct = JSON.parse(
      JSON.stringify(this.manualBooking.productName)
    );
    this.onSelectDestination();
    BookingController.setProductName(
      String(
        !this.$route.query.product ? tempProduct : this.$route.query.product
      )
    );
    const destinationParam = {
      code: String(this.$route.query.destinationCode),
      name: String(this.$route.query.destinationName),
      cityCode: String(this.$route.query.destinationCityCode),
      status: String(this.$route.query.destinationStatus),
      isCod: String(this.$route.query.destinationCod),
      type: String(this.$route.query.destinationType),
      vendor_code: String(this.$route.query.destinationVendor)
    };
    BookingController.setDestinationCity(
      !this.$route.query.destinationCode ? "" : destinationParam
    );
    const commodityParam = {
      name: String(this.$route.query.commodityName),
      code: String(this.$route.query.commodityCode)
    };
  }

  get payload(): any {
    return {
      ...this.payloadSectionOne,
      ...this.payloadSectionTwo
    };
  }

  get payloadSectionOne() {
    return {
      sttManual: this.manualBooking.sttManual,
      referenceExternal: !this.manualBooking.referenceExternal
        ? ""
        : this.manualBooking.referenceExternal,
      productName: this.manualBooking.productName,
      originCity:
        this.origin.cityCode || this.manualBooking.originCity.cityCode,
      originDistrict: this.origin.code || this.manualBooking.originCity.code,
      destinationCity: this.manualBooking.destinationCity?.cityCode || "",
      destinationDistrict: this.manualBooking.destinationCity?.code || "",
      phoneSender: `${this.manualBooking.phoneCodeSender.substring(1)}${
        this.manualBooking.phoneSender
      }`,
      phoneCodeSender: this.manualBooking.phoneCodeSender,
      phoneFlagSender: this.manualBooking.phoneFlagSender,
      phoneReceiver: `${this.manualBooking.phoneCodeReceiver.substring(1)}${
        this.manualBooking.phoneReceiver
      }`,
      phoneCodeReceiver: this.manualBooking.phoneCodeReceiver,
      phoneFlagReceiver: this.manualBooking.phoneFlagReceiver,
      sender:
        typeof this.manualBooking.sender === "object"
          ? this.manualBooking.sender?.customerName
          : this.manualBooking.sender,
      receiver:
        typeof this.manualBooking.receiver === "object"
          ? this.manualBooking.receiver?.customerName
          : this.manualBooking.receiver,
      addressSender: this.manualBooking.addressSender,
      addressReceiver: this.manualBooking.addressReceiver,
      sttShipmentId: this.manualBooking.sttShipmentId
    };
  }

  get payloadSectionTwo() {
    return {
      sttGrossWeight: parseByCountry(this.totalGrossWeight),
      sttVolumeWeight: parseByCountry(this.totalVolumeWeight),
      sttChargeableWeight: this.isCampaign
        ? parseByCountry(this.totalCampaignChargeableWeight)
        : parseByCountry(this.totalChargeableWeight),
      addressReceiverType: this.manualBooking.addressReceiverType,
      commodityCode: this.manualBooking.commodityCode.code,
      insurance: this.manualBooking.insurance,
      statusGoods: this.manualBooking.statusGoods,
      estimationPrice: parseByCountry(this.manualBooking.estimationPrice, { country: this.currencyCountry }),
      taxNumber: this.manualBooking.taxNumber,
      isWoodpack: this.manualBooking.isWoodpack,
      isCOD: this.manualBooking.isCOD || this.manualBooking.isDFOD,
      isDFOD: this.manualBooking.isDFOD,
      isCODClient:
        (this.manualBooking.isCOD || this.manualBooking.isDFOD) &&
        this.formType !== "manual",
      isDFODClient: this.manualBooking.isDFOD && this.formType !== "manual",
      isPAD: this.manualBooking.isPAD,
      codAmount: (this.dataProfile.account_type === 'client'
        ? this.formType === 'manual'
        : this.formType === 'client' &&
          this.manualBooking.clientName?.clientCodConfigAmountData?.includes(
            'goods_price'
          )) ? parseByCountry(this.manualBooking.codAmount, { country: this.currencyCountry })
            || parseByCountry(this.manualBooking.estimationPrice, { country: this.currencyCountry })
          : parseByCountry(this.manualBooking.codAmount, { country: this.currencyCountry }),
      isSaveSender: this.manualBooking.isSaveSender,
      isSaveReceiver: this.manualBooking.isSaveReceiver,
      sttPieces: this.convertedArr,
      isDO: this.isDO,
      isMixpack: this.isMixpack,
      sttPiecePerPack: Number(this.manualBooking.piecePerPack),
      sttNextCommodity: this.manualBooking.nextCommodity,
      clientName: this.manualBooking.clientName,
      clientId: this.clientIdFromShipment || this.manualBooking.clientId,
      postalCodeDestination: this.manualBooking.postalCodeDestination?.name,
      sttAttachFiles: this.additionalInfo.files
        .filter((_: string, index: number) => index <= 1)
        .filter((item: string) => item),
      sttCommodityDetail: this.additionalInfo.commodity,
      sttRecipientEmail: this.isInternational
        ? this.docInternationalForm.email
        : this.additionalInfo.email,
      sttKtpImage: this.additionalInfo.files[2],
      sttTaxImage: this.additionalInfo.files[3],
      sttWeightAttachFiles: [], //this.fileAdjustmentsFilter client only,
      sttIdentityNumber: this.isInternational
        ? this.docInternationalForm.idNumber
        : this.additionalInfo.sttIdentityNumber,
      sttInterTaxNumber: this.isInternational
        ? this.docInternationalForm.taxNumber
        : this.additionalInfo.sttInterTaxNumber,
      sttCipl: this.isInternational
        ? this.docInternationalCommodityCipl
        : [],
      sttDutyTaxTerms: this.detailRepairBulkBooking.bookingData.sttDutyTaxTerms
    };
  }

  get docInternationalCommodityCipl(): CIPLType[] {
    return this.docInternationalForm.listCommodityCIPL
      .filter((cipl: CommodityCIPL) => cipl.name)
      .map((cipl: CommodityCIPL) => ({
        itemDetail: cipl.name,
        itemDetailEn: cipl.name,
        quantity: Number(cipl.quantity),
        itemPrice: Number(
          cipl.goodsPrice
            .toString()
            .replace(/\./g, "")
            .replace(",", ".")
        ),
        commodityHsCode: cipl.commodity?.hsCode || ""
      }));
  }

  get convertedArr() {
    return this.listKGs.map((key: any) => ({
      stt_piece_length: key.dimension.length,
      stt_piece_width: key.dimension.width,
      stt_piece_height: key.dimension.height,
      stt_piece_gross_weight: parseByCountry(key.grossWeight),
      stt_piece_volume_weight: key.volumeWeight
    }));
  }

  get convertedArrPiecesPosterProduct() {
    return this.listKGs.map((key: any) => ({
      pieceLength: key.dimension.length,
      pieceWidth: key.dimension.width,
      pieceHeight: key.dimension.height,
      pieceGrossWeight: parseByCountry(key.grossWeight)
    }));
  }

  get isMixpack() {
    return AccountController.accountData.account_type === "client"
      ? AccountController.accountData.account_type_detail.isMixpack
      : false;
  }

  get isDO() {
    return this.isClientDO;
  }

  setCodDfodClient() {
    this.refs = this.$refs;
    if (
      this.formType === "client" &&
      this.getAccount.accountType === "client"
    ) {
      this.refs.packageDetail.setStatus(
        this.getAccount.accountTypeDetail.isCod,
        this.getAccount.accountTypeDetail.isDfod,
        "non-cod"
      );
    }
  }

  getCustomerList(refId?: number, refType?: string) {
    BookingController.getCustomerList({
      search: "",
      cache: true,
      refId: refId,
      refType: refType
    });
  }

  getCommodityList() {
    CommodityController.getCommodityList(
      new RequestListCommodity({
        limit: 20
      })
    );
  }

  ciplCommodityList: any[] = [];
  ciplCommoditySearch = "";
  isCiplDefaultCommodityLoaded = false;

  get ciplCommodities() {
    return this.ciplCommodityList.map((item) => ({
      id: item.commodity_id,
      name: this.accountIsNonForeign
        ? item.commodity_name
        : item.commodity_name_en,
      code: item.commodity_code,
      status: item.commodity_status,
      isDangerousGoods: item.isDangerousGoods,
      isQuarantine: item.isQuarantine
    }));
  }

  get isLoadingCiplCommodity() {
    return CommodityController.isLoading;
  }

  onFilterCiplCommodity({ search = "" }: { search?: string }) {
    this.fetchCiplCommodityList(search);
  }

  fetchCiplCommodityList = debounce(async (search = "") => {
    if (
      !search &&
      this.isCiplDefaultCommodityLoaded &&
      this.ciplCommodityList.length
    ) {
      return;
    }
    this.ciplCommoditySearch = search;
    const commodities = await CommodityController.getCommodityList(
      new RequestListCommodity({
        search,
        page: 1,
        limit: 20,
        commodityStatus: "active"
      })
    );
    this.ciplCommodityList = commodities.data;
    this.isCiplDefaultCommodityLoaded = !search;
  }, 250);

  async loadCiplCommodityList(index = 0) {
    if (this.docInternationalForm.listCommodityCIPL[index]?.name) return;
    if (
      !this.ciplCommoditySearch &&
      this.isCiplDefaultCommodityLoaded &&
      this.ciplCommodityList.length
    ) {
      return;
    }
    this.ciplCommoditySearch = "";
    const commodities = await CommodityController.getCommodityList(
      new RequestListCommodity({
        page: 1,
        limit: 20,
        commodityStatus: "active"
      })
    );
    this.ciplCommodityList = commodities.data;
    this.isCiplDefaultCommodityLoaded = true;
  }

  async fetchCiplCommodityListInfiniteScroll() {
    CommodityController.commodities.pagination.page++;
    const commodities = await CommodityController.getCommodityList(
      new RequestListCommodity({
        search: this.ciplCommoditySearch,
        page: CommodityController.commodities.pagination.page,
        limit: 20,
        commodityStatus: "active"
      })
    );
    this.ciplCommodityList.push(...commodities.data);
  }

  // route navigation
  goBack() {
    this.$router.push("/shipment/bulk/bulk-v2");
  }

  get title() {
    return this.$t(`${this.$route.meta.name}`);
  }

  get manualBooking(): ManualBooking {
    return BookingController.manualBooking;
  }
  errorEstimationPrice = false;
  errorCodGoodsPrice = false;

  getWoodPacking() {
    this.manualBooking.isWoodpack = false;
    const renderWoodPacking: any = this.$refs.woodpacking;
    renderWoodPacking.resetData();
    renderWoodPacking.getConfig();
  }

  get isFormBookManual() {
    return this.formType === "manual";
  }

  get origin() {
    const detail = LocationController.districtDetail;
    return {
      id: detail.id,
      name: `${detail.name}, ${detail.cityName}`,
      code: `${detail.code}`,
      cityId: detail.cityId,
      cityCode: `${detail.cityCode}`
    };
  }

  get cityForWoodPacking() {
    return this.origin.cityCode || this.manualBooking.originCity.cityCode;
  }

  get eligibleToWoodpacking() {
    return (
      (this.formType === "client" &&
        this.getAccount.accountType === "client") ||
      (this.formType === "client" &&
        this.getAccount.accountType === "partner") ||
      (this.formType === "client" &&
        this.getAccount.accountType === "internal") ||
      AccountController.accountData.isAllClient
    );
  }

  get flagsBulkBookingInternal() {
    return FlagsPermissionBulkBookingV2.feature_bulk_booking_internal_v2.isEnabled();
  }

  get formType() {
    const isClient =
      BulkBookingController.detailRepairBulkBookingData.bookedType === "client";
    const isAll = AccountController.accountData.isAllClient;

    return isClient && !isAll ? "client" : "manual";
  }

  get getAccount(): any {
    return {
      accountType: AccountController.accountData.account_type,
      cityCode: AccountController.accountData.account_type_detail
        .partnerLocation
        ? AccountController.accountData.account_type_detail.partnerLocation
            .city_code
        : "",
      accountClientId: AccountController.accountData.account_type_detail.id
        ? AccountController.accountData.account_type_detail.id
        : "",
      isCodBooking:
        AccountController.accountData.account_type_detail.partnerIsCodBooking,
      accountTypeDetail: AccountController.accountData.account_type_detail
    };
  }
  // error embargo
  get isErrorEmbargo() {
    return BookingController.isErrorEmbargo;
  }

  errorEmbargo = {
    originCity: false,
    destinationCity: false,
    productType: false,
    comodity: false,
    weightStatus: false,
    lengthStatus: false
  };

  updateStatusErrorEmbargo(status: boolean) {
    this.errorEmbargo.originCity = status;
    this.errorEmbargo.destinationCity = status;
    this.errorEmbargo.productType = status;
    this.errorEmbargo.comodity = status;
    this.errorEmbargo.weightStatus = status;
    this.errorEmbargo.lengthStatus = status;
  }

  onUpdateEmbargoStatusFail() {
    if (this.isErrorEmbargo) {
      this.updateStatusErrorEmbargo(false);
    }
  }

  get configHeavyWeightMinimum() {
    return HeavyWeightSurchargeController.heavyWeightMinimum;
  }

  async getConfigHws(product: any, commodity: any) {
    await HeavyWeightSurchargeController.getDetailMinimumHeavyWeightSurcharge({
      id: 1,
      product,
      commodity
    });
    if (
      this.configHeavyWeightMinimum &&
      !this.configHeavyWeightMinimum.minimumExist
    ) {
      await HeavyWeightSurchargeController.getDetailMinimumHeavyWeightSurcharge(
        {
          id: 2,
          product,
          commodity
        }
      );
    }
  }

  async onChangeCommodities() {
    this.onUpdateEmbargoStatusFail();
    if (
      this.manualBooking.productName &&
      this.manualBooking.commodityCode.code
    ) {
      await this.getConfigHws(
        this.manualBooking.productName,
        this.manualBooking.commodityCode.code
      );
      this.onSetErrorHws();
    }
  }

  autofillCommodity() {
    (this.$refs.packageDetail as any).changeCommodities();
    (this.$refs.packageDetail as any).dataListCommodities =
      CommodityController.commodities.data;
    (this.$refs.packageDetail as any).errorCommodity = false;
    (this.$refs.packageDetail as any).isCommodityNotFound = false;
  }

  autofillCommodityNotFound() {
    if (!this.manualBooking.commodityCode) {
      (this.$refs.packageDetail as any).errorCommodity = true;
      (this.$refs.packageDetail as any).isCommodityNotFound = true;
    }
  }

  onChangeDeliveryFeeType = debounce((self: any) => {
    self.pickProductUpselling(self.manualBooking.destinationCity);
  }, 500);

  get callUpselling() {
    return (
      this.manualBooking.destinationCity.code &&
      this.manualBooking.commodityCode.code &&
      this.totalChargeableWeight
    );
  }

  updateTotalChargeableWeight(value: any) {
    this.totalChargeableWeight = value;
  }
  updateTotalCampaignChargeableWeight(value: any) {
    this.totalCampaignChargeableWeight = value;
  }

  updateTotalGrossWeight(value: any) {
    this.totalGrossWeight = value;
  }

  updateTotalVolumeWeight(value: any) {
    this.totalVolumeWeight = value;
  }

  totalChargeableWeight: any = "0";
  totalGrossWeight: any = "0";
  totalVolumeWeight: any = "0";
  totalCampaignChargeableWeight: any = "0";

  closeModalError() {
    BookingController.setError(false);
    if (this.isErrorEmbargo) {
      this.updateStatusErrorEmbargo(true);
    }
  }

  get isErrorHws() {
    return this.listKGs.map((key: any) => key.errorHws).includes(true);
  }

  onSetErrorHws() {
    //set error hws
    this.showWarningHws =
      this.configHeavyWeightMinimum.minimumExist &&
      this.listKGs.length < 2 &&
      parseByCountry(+this.listKGs[0]) >=
        this.configHeavyWeightMinimum.heavyWeightMinimum;
    this.listKGs.forEach((key: any, index: number) => {
      this.listKGs[index].errorHws =
        this.configHeavyWeightMinimum.minimumExist &&
        parseByCountry(+key.grossWeight) >=
          this.configHeavyWeightMinimum.heavyWeightMinimum &&
        this.listKGs.length > 1;
    });
  }

  // error indicator mandatory
  currentFieldIndex = 0;
  setFieldIndex(index: number) {
    if (index > this.currentFieldIndex) {
      this.currentFieldIndex = index;
    }
  }

  get errorMandatory() {
    return [
      ...this.errorMandatoryDetailDelivery,
      ...this.errorMandatoryDetailGood
    ];
  }

  get errorMandatoryDetailDelivery() {
    return [
      this.errorMandatoryClientColumn,
      this.errorProductcolumn,
      this.errorMandatoryExternalReffColumn,
      !this.payload.sender && this.currentFieldIndex > 3,
      !this.payload.receiver && this.currentFieldIndex > 4,
      !this.manualBooking.phoneSender && this.currentFieldIndex > 5,
      !this.manualBooking.phoneReceiver && this.currentFieldIndex > 6,
      !this.payload.addressSender && this.currentFieldIndex > 7,
      !this.payload.addressReceiver && this.currentFieldIndex > 8,
      this.errorMandatoryDestinationColumn,
      !this.payload.destinationDistrict && this.currentFieldIndex > 10
    ];
  }

  get errorProductcolumn() {
    return !this.payload.productName && this.currentFieldIndex > 1;
  }

  get errorMandatoryClientColumn() {
    return (
      !this.payload.clientName &&
      this.getAccount.accountType === "client" &&
      this.currentFieldIndex > 0
    );
  }

  get errorMandatoryExternalReffColumn() {
    return (
      !this.payload.referenceExternal &&
      (this.isDO || (this.getAccount.accountType === "client" && this.isDO)) &&
      this.currentFieldIndex > 2
    );
  }

  get errorMandatoryDestinationColumn() {
    return (
      !this.manualBooking.originCity?.code &&
      this.getAccount.accountType === "internal" &&
      this.currentFieldIndex > 9
    );
  }

  get errorMandatoryDetailGood() {
    const newFiles = this.additionalInfo.files.filter((item: string) => item);
    return [
      !this.payload.commodityCode && this.currentFieldIndex > 11,
      false,
      !this.payload.insurance && this.currentFieldIndex > 13,
      !this.payload.estimationPrice && this.currentFieldIndex > 14,
      !this.manualBooking.codAmount && this.currentFieldIndex > 15,
      false,
      this.errorManadatoryShipmentStatus,
      this.errorMandatoryPiecePerPack,
      this.errorMandatoryNextCommodity,
      this.errorMandatoryAdditionalInfoCommodity,
      this.errorMandatoryAdditionalInfoEmail,
      newFiles.length < 3 &&
        this.isProductInterpack &&
        this.currentFieldIndex > 21,
      this.errorMandatoryAdditionalInfoIdentityNumber,
      this.errorMandatoryAdditionalInfoInterTaxNumber
    ];
  }

  get errorManadatoryShipmentStatus() {
    return (
      !this.payload.statusGoods &&
      this.isFtzAccount &&
      this.currentFieldIndex > 17
    );
  }

  get errorMandatoryPiecePerPack() {
    return (
      !this.payload.sttPiecePerPack &&
      this.isFtzAccount &&
      this.currentFieldIndex > 18
    );
  }

  get errorMandatoryNextCommodity() {
    return (
      !this.payload.sttNextCommodity &&
      this.isFtzAccount &&
      this.currentFieldIndex > 19
    );
  }

  get errorMandatoryAdditionalInfoCommodity() {
    return !this.additionalInfo.commodity && this.currentFieldIndex > 20;
  }

  get errorMandatoryAdditionalInfoEmail() {
    return !this.additionalInfo.email && this.currentFieldIndex > 20.5;
  }

  get errorMandatoryAdditionalInfoIdentityNumber() {
    return (
      !this.additionalInfo.sttIdentityNumber && this.currentFieldIndex > 21
    );
  }

  get errorMandatoryAdditionalInfoInterTaxNumber() {
    return (
      !this.additionalInfo.sttInterTaxNumber && this.currentFieldIndex > 21.5
    );
  }

  get isErrorSpesificRate() {
    return BookingController.errorSpesificByRate;
  }

  get isErrorAdd() {
    return BookingController.isError;
  }

  get errorCause() {
    return BookingController.isErrorCause;
  }

  additionalInfo: any = {
    commodity: "",
    email: "",
    sttInterTaxNumber: "",
    sttIdentityNumber: "",
    files: []
  };

  errAditionalInfo = {
    email: false,
    commodity: false,
    sttInterTaxNumber: false,
    sttIdentityNumber: false,
    files: false
  };

  docInternationalForm = new DocInternationalModelValueType();
  errorDocInternational = new ErrorBookingV3();

  get showInternationalCiplSection() {
    return this.isInternational;
  }

  get isInternational() {
    return this.isInternationalFromDetail || this.isInternationalProduct;
  }

  get isInternationalFromDetail() {
    return this.detailRepairBulkBooking.bookingData.isInternational;
  }

  get isInternationalProduct() {
    const productName = String(
      this.hasChangedRepairProduct
        ? this.manualBooking.productName
        : this.manualBooking.productName ||
            this.detailRepairBulkBooking.bookingData.productType
    ).toUpperCase();
    return ["INTERPACK", "INTERPACKMAXI"].includes(productName);
  }

  resetDocInternationalForm() {
    this.docInternationalForm = new DocInternationalModelValueType();
    this.errorDocInternational = new ErrorBookingV3();
  }

  get isProductInterpack() {
    return this.isInternational;
  }

  get eligibleAdditionalInfo() {
    return (
      FlagsMedusa.flag_release_interpack_additional_info.isEnabled() &&
      this.manualBooking.productName === "INTERPACK"
    );
  }

  get isFtzAccount() {
    return this.getAccount.accountType === "internal"
      ? this.manualBooking.originCity?.isFtz === "yes"
      : AccountController.accountData.account_location?.city_free_trade_zone ===
          "yes";
  }

  estimateSla = {
    slaMin: 0,
    slaMax: 0,
    transport: ""
  };

  get isShowWarningSla() {
    return this.estimateSla.slaMin >= 7;
  }

  fetchSlaEstimation() {
    MainAppController.showLoading();
    BookingController.checkTransportAndEstimateSlaBooking({
      originCity:
        this.origin.cityCode || this.manualBooking.originCity.cityCode,
      destinationCity: this.manualBooking.destinationCity?.cityCode || "",
      originDistrict: this.origin.code || this.manualBooking.originCity.code,
      destinationDistrict: this.manualBooking.destinationCity.code,
      product: this.manualBooking.productName
    }).then((response) => {
      this.estimateSla = response;
    });
    MainAppController.closeLoading();
  }

  get isEmbargo() {
    return BookingController.productHaveEmbargo;
  }

  get titleErrorspesification() {
    return BookingController.titleErrorspesification;
  }

  get openSuccess() {
    return BookingController.showModalSuccess;
  }

  get messageSuccess() {
    return BookingController.messageSuccess;
  }

  isSubmit = false;

  booking() {
    this.isSubmit = true;
    if (this.formType !== "client") {
      this.submitBookManualParam();
    } else {
      this.submitBookCoorporateParam();
    }
  }

  submitBookCoorporateParam() {
    BookingController.addBookingCorporate({
      payload: new AddBookingCorporate({
        sttClient: this.manualBooking.clientName.id,
        sttNo: this.payload.sttManual,
        sttShipmentId: "",
        sttNoRefExternal: this.payload.referenceExternal,
        sttTaxNumber: this.payload.taxNumber,
        sttGoodsEstimatePrice: this.payload.estimationPrice,
        sttGoodsStatus: this.payload.statusGoods || "ecommerce",
        sttOriginCityId: this.payload.originCity,
        sttOriginDistrictId: this.payload.originDistrict,
        sttDestinationCityId: this.payload.destinationCity,
        sttDestinationDistrictId: this.payload.destinationDistrict,
        sttSenderName: this.payload.sender,
        sttSenderPhone: this.payload.phoneSender,
        sttSenderAddress: this.payload.addressSender,
        sttRecipientName: this.payload.receiver,
        sttRecipientAddress: this.payload.addressReceiver,
        sttRecipientAddressType: this.payload.addressReceiverType,
        sttRecipientPhone: this.payload.phoneReceiver,
        sttInsuranceType: this.payload.insurance,
        sttProductType: this.payload.productName,
        sttCommodityCode: this.payload.commodityCode,
        sttClientSttId: 0,
        sttVendorSttId: 0,
        sttIsCod: this.payload.isCODClient,
        sttIsDfod: this.payload.isDFODClient,
        sttIsWoodpacking: this.payload.isWoodpack,
        sttPieces: this.payload.sttPieces,
        sttPiecePerPack: Number(this.manualBooking.piecePerPack),
        sttNextCommodity: this.manualBooking.nextCommodity,
        sttCodAmount: this.payload.codAmount,
        postalCodeDestination: this.manualBooking.postalCodeDestination?.name,
        sttWeightAttachFiles: [],
        sttRecipientEmail: this.additionalInfo.email,
        sttKtpImage: this.additionalInfo.files[2],
        sttTaxImage: this.additionalInfo.files[3],
        sttAttachFiles: this.payload.sttAttachFiles,
        sttCommodityDetail: this.payload.sttCommodityDetail,
        sttIdentityNumber: this.additionalInfo.sttIdentityNumber,
        sttInterTaxNumber: this.additionalInfo.sttInterTaxNumber
      }),
      isBookingClient: true
    });
  }

  onEnterBooking(event: any) {
    this.isSubmit = false;
    if (event.key === "Enter") {
      if (this.getIsDisableButton) {
        this.setFieldIndex(19);
        return;
      }
      this.enterbookingSuccess();
    }
  }

  enterbookingSuccess() {
    if (!this.isSubmit && !this.isLoading) {
      if (!this.openSuccess) {
        this.booking();
        return;
      }
    }
  }

  async submitBookManualParam() {
    try {
      const createbooking: ResponsePayload = await BookingController.addManualBooking(
        this.payloadBookingManual
      );

      await BookingController.onSuccessBooking({
        sttNumber: createbooking.sttNumber,
        sttId: createbooking.sttId,
        chargeableWeight: createbooking.chargeableWeight
      });
    } catch (error) {
      BookingController.generateErrorBooking({
        err: error,
        payload: this.payloadBookingManual,
        errorFor: "book",
        calllFunctionAgain: this.submitBookManualParam
      });
    } finally {
      BookingController.finalCreateBooking();
    }
  }

  get payloadBookingManual() {
    return new AddManualBooking({
      sttManual: this.payload.sttManual,
      referenceExternal: this.payload.referenceExternal,
      productName: this.payload.productName,
      originCity: this.payload.originCity,
      originDistrict: this.payload.originDistrict,
      destinationCity: this.payload.destinationCity,
      destinationDistrict: this.payload.destinationDistrict,
      phoneSender: this.payload.phoneSender,
      phoneReceiver: this.payload.phoneReceiver,
      sender: this.payload.sender,
      receiver: this.payload.receiver,
      addressSender: this.payload.addressSender,
      addressReceiver: this.payload.addressReceiver,
      addressReceiverType: this.payload.addressReceiverType,
      sttGrossWeight: this.payload.sttGrossWeight,
      sttVolumeWeight: this.payload.sttVolumeWeight,
      sttChargeableWeight: this.payload.sttChargeableWeight,
      commodityCode: this.payload.commodityCode,
      insurance: this.payload.insurance,
      statusGoods: this.payload.statusGoods,
      estimationPrice: this.payload.estimationPrice,
      taxNumber: this.payload.taxNumber,
      isWoodpack: this.payload.isWoodpack,
      isCOD: this.payload.isCOD,
      isDFOD: this.payload.isDFOD,
      sttAttachFiles: this.payload.sttAttachFiles,
      sttCommodityDetail: this.payload.sttCommodityDetail,
      isSaveSender: this.payload.isSaveSender,
      isSaveReceiver: this.payload.isSaveReceiver,
      sttPieces: this.payload.sttPieces,
      isDO: this.payload.isDO,
      isMixpack: this.payload.isMixpack,
      sttPiecePerPack: this.payload.sttPiecePerPack,
      sttNextCommodity: this.payload.sttNextCommodity,
      sttCodAmount: this.payload.codAmount,
      postalCodeDestination: this.payload.postalCodeDestination,
      isPAD: this.payload.isPAD,
      sttWeightAttachFiles: [],
      sttRecipientEmail: this.additionalInfo.email,
      sttKtpImage: this.additionalInfo.files[2],
      sttTaxImage: this.additionalInfo.files[3],
      sttIdentityNumber: this.additionalInfo.sttIdentityNumber,
      sttInterTaxNumber: this.additionalInfo.sttInterTaxNumber,
      sttShipmentId: this.manualBooking.sttShipmentId
    });
  }

  listKGs: any = [];

  refs: any = "";

  isProductSelected = false;
  async onSelectProduct(obj: any) {
    this.refs = this.$refs;
    this.refs.sttManualReference.validateSttManual(
      this.manualBooking.sttManual
    );
    if (obj) {
      if (obj.status === "ACTIVE") {
        if (
          this.manualBooking.productName !== "INTERPACK" &&
          obj.name === "INTERPACK"
        ) {
          this.listKGs = [this.listKGs[0]];
        }
        this.isProductSelected = true;
        BookingController.setProductName(obj.name);
        for (let i = 0; i < this.listKGs.length; i++) {
          this.refs.goodsWeight?.calculationVolumeWeight(i);
        }
        this.refs.sttManualReference?.validateSttManual(
          this.manualBooking.sttManual
        );
        this.fetchSlaEstimation();
        this.refs.packageDetail.inputEstimationPrice(
          this.manualBooking.estimationPrice
        );
      } else {
        this.error.product = true;
      }
      this.setStatusInsurance(obj.name, obj.status === "ACTIVE", this.refs);
      // this.callZiCode();
    } else {
      this.isProductSelected = false;
      this.isClientDO = true;
      this.manualBooking.sttManual = "";
    }

    if (this.isErrorEmbargo) {
      this.updateStatusErrorEmbargo(false);
    }
    if (
      this.manualBooking.productName &&
      this.manualBooking.commodityCode.code
    ) {
      // get config hws
      // on set error hws
      await this.getConfigHws(obj.name, this.manualBooking.commodityCode.code);
      this.onSetErrorHws();
    }
    this.isErrorRepair.productType = false;
  }

  resetZipCode() {
    if (this.accountIsNonForeign) {
      BookingController.setPostalCodeDestination("");
    }
  }

  disableAsuranceOtoPack = false;
  statusProduct = false;
  setStatusInsurance(
    productName: string,
    productStatus: boolean,
    ref: any = ""
  ) {
    this.statusProduct = productStatus;
    const product =
      (productName === "OTOPACK150" || productName === "OTOPACK250") &&
      productStatus;
    if (product) {
      // validate insurance
      ref.packageDetail.automaticSetCheckbox(
        parseByCountry(+this.manualBooking.estimationPrice)
      );
      this.disableAsuranceOtoPack = true;
      this.processErrorEstimationPrice(this.manualBooking.estimationPrice);
    } else {
      this.disableAsuranceOtoPack = false;
      ref.packageDetail.automaticSetCheckbox(
        parseByCountry(+this.manualBooking.estimationPrice)
      );
    }
  }

  processErrorEstimationPrice(price: string) {
    const isNonCodValidate = !this.manualBooking.isCOD;
    const estimation = parseByCountry(price);
    if (isNonCodValidate) {
      this.validateOttopack(estimation);
    }
  }

  validateOttopack(estimation: number) {
    if (this.disableAsuranceOtoPack && this.estimationForOttopack(estimation)) {
      // this.errorEstimationPrice = true;
    } else {
      this.errorEstimationPrice = false;
    }
  }

  estimationForOttopack(estimasi: number) {
    return estimasi > 0 && estimasi < 5000000;
  }

  isInvalidCodAndDfod(isCodValidate: boolean, isDfodValidate: boolean) {
    return (
      (!this.manualBooking.isCOD && isCodValidate) ||
      (!this.manualBooking.isDFOD && isDfodValidate)
    );
  }
  errorDestintaionProductUpselling = false;
  setErrorDestintaionProductUpselling(status: boolean) {
    this.errorDestintaionProductUpselling = status;
    BookingController.setErrorDestination(status);
  }
  get isOnePack() {
    return (
      (this.formType === "client" &&
        this.getAccount.accountType === "client") ||
      this.formType === "client"
    );
  }
  get isShowJumbopack() {
    return (
      ((this.formType === "client" &&
        this.getAccount.accountType === "client") ||
        this.formType === "client") &&
      flags.show_jumbopack_on_booking_page.isEnabled()
    );
  }
  get accountIsNonForeign() {
    return !AccountController.accountData.accountIsForeign;
  }

  error = {
    sttManual: false,
    productName: false,
    taxNumber: false,
    errorRefExternal: false,
    successPhoneSender: false,
    phoneSender: false,
    phoneCodeSender: false,
    phoneCharMinimalSender: false,
    errorMessagePhoneSender: "",
    successPhoneReceiver: false,
    phoneReceiver: false,
    phoneCodeReceiver: false,
    phoneCharMinimalReceiver: false,
    errorMessagePhoneReceiver: "",
    estimationPrice: false,
    grossWeight: false,
    product: false,
    insurance: false,
    errorMandatoryClientColumn: false,
    sttShipmentId: false
  };

  get isErrorRepair() {
    return BulkBookingController.isErrorRepair;
  }

  get isVendorNinjaDestination() {
    return BookingController.isVendorNinjaDestination;
  }

  setIsVendorNinjaDestination(val: boolean) {
    BookingController.setIsVendorNinjaDestination(val);
  }

  detailDistrict = new DistrictData();

  async onSelectDestination(type = "") {
    if (!type) {
      this.postalCodeDestinationOptions = [];
    }
    this.refs = this.$refs;
    BookingController.setProductName("");
    BookingController.setErrorDestination(false);
    if (!this.refs?.recipientDetail) return;
    if (!this.manualBooking.destinationCity?.id) {
      this.manualBooking.destinationCountry = new CountryData();
      return;
    }
    const resp = await this.refs.recipientDetail.fetchDistrictId(
      this.manualBooking.destinationCity?.id
    );
    if (resp.name !== "") {
      this.detailDistrict = resp;
    }
    // reset photo here

    if (this.isErrorEmbargo) {
      this.updateStatusErrorEmbargo(false);
    }
    if (this.isVendorNinjaDestination) {
      this.setIsVendorNinjaDestination(false);
    }

    this.checkIfCod(
      this.manualBooking.destinationCity?.isCod === "yes",
      this.isDO
    );

    this.resetAdditionalInfoInterpack();
    this.callZiCode(type);
    this.callZipCodeForForeign(type);
    this.pickProductUpselling(this.manualBooking.destinationCity);
    this.getDocumentInternational();
    this.onUpdateDestinationCountryDetail();
  }

  resetAdditionalInfoInterpack() {
    this.additionalInfo = {
      commodity: "",
      email: "",
      sttInterTaxNumber: "",
      sttIdentityNumber: "",
      files: []
    };
    this.errAditionalInfo = {
      email: false,
      commodity: false,
      sttInterTaxNumber: false,
      sttIdentityNumber: false,
      files: false
    };
  }

  pickProductUpselling(val: any) {
    if (val) {
      this.loadUpsellingProductByCondition();
    } else {
      this.resetProductUpselling();
    }
  }

  resetProductUpselling() {
    const renderPoster: any = this.$refs.renderPoster;
    renderPoster?.resetAllProduct();
  }

  loadUpsellingProductByCondition() {
    this.loadUpsellingProductForManualBook();
    this.loadUpsellingProductForClientBook();
  }

  loadUpsellingProduct() {
    const visiblePricePosterProduct =
      this.isFormBookManual && this.getAccount.accountType === "partner";
    const renderPoster: any = this.$refs.renderPoster;
    renderPoster?.getPosterProduct(
      "",
      this.origin.code || this.manualBooking.originCity.code,
      this.manualBooking.destinationCity.code,
      visiblePricePosterProduct,
      this.clientlientIdForProductUpselling.accountRefId,
      this.clientlientIdForProductUpselling.accountType,
      this.manualBooking.estimationPrice,
      this.manualBooking.commodityCode,
      this.convertedArrPiecesPosterProduct,
      this.payload.isCOD,
      this.payload.isDFOD
    );
  }

  get clientlientIdForProductUpselling() {
    let accountRefId = 0;
    let accountType = "";

    if (this.isFormBookManual && this.getAccount.accountType === "partner") {
      accountRefId = 0;
      accountType = "pos";
    } else if (
      this.formType === "client" &&
      this.getAccount.accountType === "partner"
    ) {
      accountRefId = this.manualBooking.clientName.id;
      accountType = "client";
    } else if (
      this.isFormBookManual &&
      this.getAccount.accountType === "client"
    ) {
      accountRefId = this.getAccount.accountClientId;
      accountType = "client";
    } else {
      accountRefId = this.manualBooking.clientName.id;
      accountType = "client";
    }

    if (
      this.flagEnableHandleSelectClientIdFromShipment &&
      this.clientIdFromShipment !== 0
    ) {
      accountRefId = this.clientIdFromShipment;
    }

    return {
      accountRefId,
      accountType
    };
  }

  loadUpsellingProductForManualBook() {
    if (
      this.isFormBookManual &&
      this.OriginAndDestinationFullfilledForManualBook
    ) {
      this.loadUpsellingProduct();
    }
  }

  loadUpsellingProductForClientBook() {
    if (this.fullFilledUpsellingProductForClient) {
      this.loadUpsellingProduct();
    }
  }

  get originFullfilledForManualBook() {
    return this.manualBooking.originCity || this.origin.id;
  }

  get fullFilledUpsellingProductForClient() {
    return (
      this.originFullfilledForManualBook &&
      this.clientNameAndDestinationFullfilledForManualBook
    );
  }

  get OriginAndDestinationFullfilledForManualBook() {
    return this.origin.id && this.manualBooking.destinationCity;
  }

  get clientNameAndDestinationFullfilledForManualBook() {
    return this.manualBooking.clientName && this.manualBooking.destinationCity;
  }
  async callZipCodeForForeign(type: string) {
    if (this.manualBooking.destinationCity && !this.accountIsNonForeign) {
      this.callMainZipCode(type);
    }
  }

  get zipCodeForDestinationAndProduct() {
    return (
      this.manualBooking.destinationCity &&
      this.manualBooking.productName === "INTERPACK"
    );
  }

  // postal code
  postalCodeDestinationOptions: any = [];
  setPostalCode(value: any) {
    this.postalCodeDestinationOptions = value;
  }
  setPostalCodeDestination(value: string) {
    if (value) {
      BookingController.setPostalCodeDestination({
        id: value,
        name: value
      });
      return;
    }
    BookingController.setPostalCodeDestination("");
  }

  mapPostalCodeOptions(districtData: DistrictData, zipCode = "") {
    return {
      id: districtData.id,
      name: zipCode,
      districtName: districtData.name,
      cityName: districtData.cityName,
      code: districtData.code,
      vendorCode: districtData.vendorCode,
      cityCode: districtData.cityCode,
      type: districtData.type,
      isCod: districtData.isCod,
      status: districtData.status,
      postalCode: zipCode,
      originZipCode: districtData.originZipCode
    };
  }

  mapZipCodeList(districtData: DistrictData) {
    return districtData.destinationListZipCode.length
      ? districtData.destinationListZipCode
      : this.manualBooking.destinationCity.postalCode
      ? [this.manualBooking.destinationCity.postalCode]
      : [];
  }

  async callMainZipCode(type = "") {
    const responseDistrictData = await LocationController.getDetailDistrict({
      id: this.manualBooking.destinationCity.id,
      notSaveDetail: true
    });
    const zipCode =
      responseDistrictData.destinationZipCode ||
      this.manualBooking.destinationCity.postalCode;
    const zipCodeList = this.mapZipCodeList(responseDistrictData);
    this.postalCodeDestinationOptions = zipCodeList.map((item: any) => {
      return this.mapPostalCodeOptions(responseDistrictData, item);
    });
    if (!zipCode || !zipCodeList.length) return;
    if (!zipCodeList.length) {
      this.postalCodeDestinationOptions = [];
      if (type !== "zipcode") {
        BookingController.setPostalCodeDestination("");
      }
      return;
    }

    if (zipCode.includes(",")) {
      this.postalCodeDestinationOptions = zipCodeList.map((item: any) => {
        return this.mapPostalCodeOptions(responseDistrictData, item);
      });

      BookingController.setPostalCodeDestination(
        this.manualBooking.destinationCity.postalCode
          ? this.mapPostalCodeOptions(
              responseDistrictData,
              this.manualBooking.destinationCity.postalCode
            )
          : this.postalCodeDestinationOptions[0]
      );
    } else {
      BookingController.setPostalCodeDestination(
        this.mapPostalCodeOptions(responseDistrictData, zipCode)
      );
      this.postalCodeDestinationOptions = zipCodeList.map((zc: string) => {
        return this.mapPostalCodeOptions(responseDistrictData, zc);
      });
    }
  }

  async callZiCode(type: string) {
    this.callMainZipCode(type);
  }

  getClientID() {
    if (this.getAccount.accountType === "client") {
      ClientManagementController.getDetail(this.getAccount.accountClientId);
    }
  }

  get detailClientID() {
    return ClientManagementController.detailClientManagement;
  }
  checkIfCod(
    destination: boolean,
    client: boolean = this.detailClientID.clientIsCod
  ) {
    if (this.formType === "client") {
      if (!client || !destination) {
        BookingController.setCOD(false);
        BookingController.setDfod(false);
        BookingController.setCODAmount(0);
      }
    } else {
      if (!destination) {
        BookingController.setCOD(false);
        BookingController.setDfod(false);
        BookingController.setCODAmount(0);
      }
    }
  }

  get disableSaveReceiver() {
    return (
      !this.manualBooking.receiver ||
      !this.manualBooking.phoneReceiver ||
      !this.manualBooking.phoneCodeReceiver ||
      !this.manualBooking.addressReceiver ||
      this.error.phoneReceiver ||
      this.error.phoneCodeReceiver
    );
  }

  showWarningHws = false;

  // Validation
  get isMaxAddKgs() {
    return this.listKGs.length < 15;
  }

  productConfigurationRuleList: ProductConfigurationRuleList = new ProductConfigurationRuleList();

  get productConfigRuleActive() {
    const isRetailAllowed =
      this.isFormBookManual && this.getAccount.accountType === "partner";

    return this.productConfigurationRuleList.findProductConfigRule(
      this.manualBooking.productName,
      this.manualBooking.clientName?.id || this.detailClientID.id,
      isRetailAllowed
    );
  }

  get isCampaign() {
    return this.productConfigRuleActive.isCampaign;
  }

  get isDisabledButton() {
    return this.isFormBookManual
      ? this.disableButtonBookManual
      : this.disableButtonClient;
  }

  get disableButtonBookManual() {
    return (
      !this.isFormValid ||
      this.validateTotalGrossWeight ||
      this.validateTotalVolumeWeight ||
      this.isShipperAndConsigneeAddressIdentical ||
      !this.isValidPostalCodeDestination ||
      this.validateGrossWeightJumbopack
    );
  }
  get isValidPostalCodeDestination() {
    if (this.manualBooking.productName === "INTERPACK") {
      return !!this.manualBooking.postalCodeDestination?.id;
    }
    return true;
  }

  get validateGrossWeightJumbopack() {
    const value = this.totalChargeableWeight < 30;
    return this.manualBooking.productName === "JUMBOPACK" && !!value;
  }

  get isErrorCommodity() {
    return this.manualBooking.commodityCode?.status === "inactive";
  }

  get isFormValid() {
    return (
      this.formValidationReferenceExternal &&
      !!this.formValidationShipmentDetail &&
      !!this.formValidationShipmentGood &&
      this.fomValidationOthers &&
      this.isFormValidationError &&
      !!this.manualBooking.postalCodeDestination?.id &&
      this.isErrorValidationForm
    );
  }

  get isErrorValidationForm() {
    return !this.errorState && !this.isErrorRepair.serviceType;
  }

  get isShipperAndConsigneeAddressIdentical() {
    if (
      this.manualBooking.addressSender === "" ||
      this.manualBooking.addressReceiver === ""
    ) {
      return false;
    }
    return (
      this.manualBooking.addressSender.toLowerCase() ===
      this.manualBooking.addressReceiver.toLowerCase()
    );
  }

  get disableButtonClient() {
    return (
      !this.isFormValidClient ||
      this.validateTotalGrossWeight ||
      this.validateTotalVolumeWeight ||
      this.isShipperAndConsigneeAddressIdentical ||
      !this.isValidPostalCodeDestination ||
      this.validateGrossWeightJumbopack
    );
  }

  get isFormValidClient() {
    return (
      this.formValidationClient &&
      !this.errorState &&
      this.manualBooking.postalCodeDestination?.id &&
      !this.error.sttManual &&
      !this.isErrorRepair.serviceType
    );
  }

  get formValidationClient() {
    return (
      this.formValidationClientShipmentDetail &&
      this.formValidationClientShipmentGood &&
      this.formValidationClientShipmentOthers &&
      this.formValidationClientShipmentError &&
      this.formValidationClientExternalRef
    );
  }

  get formValidationClientExternalRef() {
    return this.isDO ? this.payload.referenceExternal : true;
  }

  get formValidationClientShipmentDetail() {
    return (
      this.payload.destinationCity &&
      this.payload.destinationDistrict &&
      this.payload.phoneCodeReceiver &&
      this.manualBooking.phoneReceiver &&
      this.payload.phoneCodeSender &&
      this.manualBooking.phoneSender &&
      this.payload.sender &&
      this.payload.receiver &&
      this.payload.addressSender &&
      this.payload.addressReceiver
    );
  }

  get isValidCommodity() {
    return (
      this.payload.commodityCode &&
      this.manualBooking.commodityCode?.status === "active"
    );
  }

  get formValidationClientShipmentGood() {
    return (
      this.payload.productName &&
      this.payload.sttGrossWeight &&
      this.payload.sttChargeableWeight &&
      this.isValidCommodity &&
      this.payload.insurance &&
      this.payload.estimationPrice &&
      this.checkIntersection()
    );
  }

  get formValidationClientShipmentOthers() {
    return (
      this.manualBooking.clientName &&
      !this.isErrorClient &&
      this.checkIsOrigincityFilled &&
      this.payload.addressReceiverType &&
      this.isFtzRequiredForm &&
      this.validationVendorNinja &&
      !this.errorEstimationPrice
    );
  }

  get checkIsOrigincityFilled() {
    if (this.getAccount.accountType === "partner" && !this.payload.originCity) {
      return false;
    } else
      return !(
        this.getAccount.accountType === "internal" &&
        !this.manualBooking.originCity
      );
  }

  get formValidationClientShipmentError() {
    return (
      !this.error.product && !this.error.insurance && !this.error.sttManual
    );
  }

  get errorState() {
    let result: any = false;
    Object.entries({
      ...this.error,
      errorEstimationPrice: this.errorEstimationPrice,
      errorCodGoodsPrice: this.errorCodGoodsPrice,
      ...(!this.showInternationalCiplSection ? this.errAditionalInfo : {})
    }).forEach(([, value]) => {
      if (value) {
        result = value;
      }
    });
    return result;
  }

  get formValidationShipmentDetail() {
    return (
      this.payload.sender &&
      this.payload.receiver &&
      this.payload.phoneCodeReceiver &&
      this.manualBooking.phoneReceiver &&
      this.payload.phoneCodeSender &&
      this.manualBooking.phoneSender &&
      this.payload.addressSender &&
      this.payload.addressReceiver &&
      this.payload.addressReceiverType
    );
  }

  get formValidationReferenceExternal() {
    if (!this.isDO) {
      return true;
    }
    return (
      this.manualBooking.referenceExternal && this.payload.referenceExternal
    );
  }

  get formValidationShipmentGood() {
    return (
      this.payload.productName &&
      this.payload.commodityCode &&
      this.manualBooking.commodityCode?.status === "active" &&
      this.payload.insurance &&
      this.payload.estimationPrice &&
      this.payload.sttGrossWeight &&
      this.payload.sttChargeableWeight
    );
  }

  checkIntersection() {
    const result = true;
    for (const el of this.convertedArr) {
      if (
        this.piecesAreZero(
          el.stt_piece_gross_weight,
          el.stt_piece_width,
          el.stt_piece_length,
          el.stt_piece_height
        )
      ) {
        return false;
      }
    }
    return result;
  }

  piecesAreZero(weight: number, width: number, length: number, height: number) {
    return weight === 0 || width === 0 || length === 0 || height === 0;
  }

  get isFtzRequiredForm() {
    if (this.isFtzAccount && this.accountIsNonForeign) {
      return !!(
        this.manualBooking.taxNumber &&
        this.manualBooking.statusGoods &&
        this.manualBooking.piecePerPack &&
        this.manualBooking.nextCommodity
      );
    }

    if (this.isFtzAccount && !this.accountIsNonForeign) {
      return !!this.manualBooking.taxNumber;
    }

    return true;
  }

  get validationVendorNinja() {
    let result = true;
    if (this.isVendorNinjaDestination && this.listKGs.length > 1) {
      result = false;
    }
    return result;
  }

  get fomValidationOthers() {
    return (
      this.payload.destinationCity &&
      this.payload.destinationDistrict &&
      this.checkIntersection() &&
      this.isFtzRequiredForm &&
      this.validationVendorNinja
    );
  }

  get isFormValidationError() {
    return (
      !this.error.product &&
      !this.error.insurance &&
      !this.error.sttManual &&
      !this.errorEstimationPrice
    );
  }

  get validateTotalGrossWeight(): boolean {
    const total = parseByCountry(this.totalGrossWeight);
    return total > maxKg;
  }

  get validateTotalVolumeWeight(): boolean {
    let total = 0;
    this.listKGs.map((e: any) => (total += Number(e.volumeWeight)));
    return total > maxKg;
  }

  get disableDetailCommodity() {
    if (this.isProductInterpack) {
      return (
        this.errAditionalInfo.commodity ||
        (this.internationalDocumentDetail.commodity
          ? !this.additionalInfo.commodity
          : false)
      );
    }

    return false;
  }

  get disableEmail() {
    if (this.isProductInterpack) {
      return (
        this.errAditionalInfo.email ||
        (this.internationalDocumentDetail.email
          ? !this.additionalInfo.email
          : false)
      );
    }

    return false;
  }

  disableAdditionalIdentity(key: any, docKey: any) {
    if (this.isProductInterpack) {
      return (
        (this.errAditionalInfo as any)[key] ||
        ((this.internationalDocumentDetail as any)[docKey]
          ? !this.additionalInfo[key]
          : false)
      );
    }

    return false;
  }
  get disableProofCommodity() {
    if (this.isProductInterpack) {
      return this.errAditionalInfo.files;
    }

    return false;
  }

  get internationalDocumentDetail() {
    return InternationalDocumentController.internationalDocumentDetail;
  }

  get accountRefAndCommodity() {
    return {
      accountRefId: this.manualBooking.sttManual?.id,
      commodityId: this.manualBooking.commodityCode.id
    };
  }

  get isCodRetailApplied() {
    return this.manualBooking.isCOD || this.manualBooking.isDFOD;
  }

  get isGrossWeight() {
    const x = parseByCountry(this.totalGrossWeight);
    const y = parseByCountry(this.totalVolumeWeight);
    return x > y;
  }

  get isVolumeWeight() {
    const x = parseByCountry(this.totalGrossWeight);
    const y = parseByCountry(this.totalVolumeWeight);
    return x < y;
  }

  discount: Diskon = {
    isDiscount: false,
    totalTariff: 0,
    totalAfterDiscount: 0,
    totalBeforeDiscount: 0
  };

  setDiscount(params: Diskon) {
    this.discount = {
      isDiscount: params.isDiscount,
      totalTariff: params.totalTariff,
      totalAfterDiscount: params.totalAfterDiscount,
      totalBeforeDiscount: params.totalBeforeDiscount
    };
  }

  get isCODSelected() {
    return this.payload.isCOD === true && this.payload.isDFOD === false;
  }

  get isDFODSelected() {
    return this.payload.isDFOD;
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  async getDocumentInternational() {
    const { originCity, destinationCity } = this.manualBooking;

    if (originCity && destinationCity) {
      await InternationalDocumentController.getInternationalDocumentDetail({
        origin: this.origin?.cityId || originCity?.cityId,
        dest: destinationCity?.cityId
      });
    }
  }

  get getIsDisableButton() {
    return (
      this.isDisabledButton ||
      this.isErrorHws ||
      (this.eligibleAdditionalInfo &&
        !this.showInternationalCiplSection &&
        (this.disableDetailCommodity ||
          this.disableEmail ||
          this.disableProofCommodity ||
          this.disableAdditionalIdentity(
            "sttIdentityNumber",
            "idcIsIdentityNumber"
          ) ||
          this.disableAdditionalIdentity(
            "sttInterTaxNumber",
            "idcIsTaxIdentificationNumber"
          ))) ||
      (this.showInternationalCiplSection && this.hasErrorDocInternational)
    );
  }

  get hasErrorDocInternational() {
    const ciplItems = this.docInternationalForm.listCommodityCIPL;
    const hasIncompleteCipl =
      !ciplItems.length ||
      ciplItems.some(
        (cipl: CommodityCIPL) =>
          !cipl.name || !cipl.quantity || !cipl.goodsPrice
      );

    return !!(
      hasIncompleteCipl ||
      this.errorDocInternational.emailDocInternational ||
      this.errorDocInternational.idNumberDocInternational ||
      this.errorDocInternational.taxNumberDocInternational ||
      this.errorDocInternational.listCommodityCIPLDocInternational.some(
        (row: string[]) => row.some((e: string) => !!e)
      ) ||
      this.errorDocInternational.dutyTaxTermsDocInternational
    );
  }

  setModelValueFormGetDetail(val: DetailRepairBulkBooking) {
    BookingController.setModelValueFormGetDetailRepair(val);
  }

  filterDistrict(response: any) {
    return response
      .filter((key: any) => key.status.toLowerCase() === "active")
      .map((e: any) => ({
        ...e,
        id: e.id,
        name: `${e.name}, ${e.cityName}`,
        code: `${e.code}`,
        cityId: e.cityId,
        cityCode: `${e.cityCode}`,
        status: e.status,
        type: e.type,
        vendor_code: e.vendorCode,
        isCod: e.isCod,
        isFtz: e.isFtz,
        originZipCode: e.originZipCode
      }));
  }

  destinationCityFromDetail =
    BulkBookingController.detailRepairBulkBookingData.bookingData
      .destinationCity;

  destinationCityList: Array<any> =
    this.destinationCityFromDetail === this.manualBooking.destinationCity
      ? [this.destinationCityFromDetail]
      : [];

  fetchDestinationCity = debounce(async (search: string) => {
    const response = await LocationController.getDistrictList({
      search: search,
      status: "",
      page: 1,
      limit: 10,
      type:
        this.manualBooking.sttReturnCod === "Yes"
          ? "within-city,forward-area"
          : "",
      cache: true
    });
    this.destinationCityList = this.filterDistrict(response);
  }, 250);

  onErrorShipmentId() {
    (this.$refs.sttManualReference as any).validateShipmentId(
      this.manualBooking.sttShipmentId
    );
  }

  onClearProducts() {
    this.errAditionalInfo.files = false;
  }

  scrollBottom(errorRepair: any) {
    const firstError = errorRepairPosition.find((item) => {
      const value = errorRepair[item.name as keyof typeof errorRepair];
      return value !== null && value !== undefined;
    });

    if (!firstError?.position) return;

    document
      .getElementById(firstError.position)
      ?.scrollIntoView({ behavior: "smooth" });
  }

  async onNextRepair(): Promise<void> {
    this.scrollToTop();
    await this.getRepairBulkDetail();
  }

  onDoneRepair(): void {
    this.answer = true;
    this.goBack();
  }

  clientIdFromShipment = 0;

  async handleGetClientDataFromShipment(clientData: any) {
    this.clientIdFromShipment = 0;
    await this.$nextTick();
    this.clientIdFromShipment = clientData.clientId;
    await this.fetchDetail(clientData.clientId);
    if (this.flagEnableHandleSelectClientIdFromShipment) {
      BookingController.setClientName(
        ClientManagementController.detailClientManagement.clientName
      );
      BookingController.setClientId(
        ClientManagementController.detailClientManagement.id
      );
      this.pickProductUpselling(this.manualBooking.clientName);
    }
  }

  get flagEnableHandleSelectClientIdFromShipment() {
    return FlagsPermissionBooking.permission_generate_client_data_from_shipment_id.isEnabled();
  }

  async recheckShipmentId() {
    if (this.clientIdFromShipment !== 0) {
      this.handleGetClientDataFromShipment({
        clientId: this.clientIdFromShipment
      });
    }
  }

  get isCrossCountryRoute(): boolean {
    return (
      !!this.manualBooking.destinationCity?.id &&
      this.manualBooking.destinationCountry.code !==
        this.manualBooking.originCountry.code
    );
  }

  get isCrossCountryCod(): boolean {
    return (
      this.isCrossCountryRoute &&
      (this.manualBooking.isCOD || this.manualBooking.isDFOD)
    );
  }

  get originCurrencyCountry(): string {
    return (
      this.manualBooking.originCountry?.code ||
      AccountController.accountData?.countryCode?.toUpperCase() ||
      "ID"
    );
  }

  get currencyCountry(): string {
    return resolveMoneyFormatCountry(
      this.isCrossCountryCod
        ? this.manualBooking.destinationCountry.code
        : this.originCurrencyCountry
    );
  }

  get prefixCurrency() {
    if (this.isCrossCountryCod) {
      return this.manualBooking.destinationCountry.currencySymbol;
    }
    if (this.manualBooking.originCountry?.code) {
      return resolveMoneyFormatCountry(this.originCurrencyCountry) === "ID"
        ? "RP"
        : this.manualBooking.originCountry.currencySymbol || "RM";
    }

    return this.accountIsNonForeign ? "RP" : "RM";
  }

  countryList = [] as CountryData[];
  async getCountryList() {
    const res = await LocationController.getCountryList({
      search: "",
      status: "active",
      page: 1,
      limit: 200
    });

    if (!res?.countryData) return;

    this.countryList = res.countryData;
  }

  async onUpdateOriginCountryDetail() {
    this.manualBooking.originCountry = this.detailRepairBulkBooking.bookingData.originCountry;
  }

  async onUpdateDestinationCountryDetail() {
    const selectedCountry = new CountryData(
      this.countryList.find(
        (item) => item.code === this.manualBooking.destinationCity?.countryCode
      )
    );

    this.manualBooking.destinationCountry = selectedCountry;
  }
}
